import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    centauri: localStorage.getItem('centauri') || null,
  },
  reducers: {
    setCentauri: (state, action) => {
      state.centauri = action.payload;
      localStorage.setItem('centauri', action.payload); 
    },
    clearCentauri: (state) => {
      state.centauri = "undefined";
      localStorage.removeItem('centauri');
    },
  },
});

export const { setCentauri, clearCentauri } = authSlice.actions;
export default authSlice.reducer;